import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import UserForm from '../forms/UserForm';
import '../styles/EmployeeMaster.css';
import UserTable from '../components/UserTable';

const UserModel = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const showModal = location.pathname === '/users/add';

  const handleAddClick = () => {
    navigate('/users/add');
  };

  const handleCloseModal = () => {
    navigate('/users');
  };

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>User Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add USER
        </button>
      </div>

      <UserTable />

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New USER</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserForm />
        </Modal.Body>
        {/* <Modal.Footer> */}
          {/* <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button> */}
          {/* <Button variant="primary">
            Save
          </Button> */}
        {/* </Modal.Footer> */}
      </Modal>
    </div>
  );
};

export default UserModel;
